module.exports = __webpack_public_path__ + "img/ninebot-icon.49e51a90.png";